export default "__VITE_ASSET__TX62mu3x__"